import React from 'react';
import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import moment from 'moment'
import * as Actions from './actions'
import LegalDisclaimer from '../LegalDisclaimer'
import SuccessMessage from '../SuccessMessage'
import { cloneDeep } from 'lodash';

// APPLICATION FORM LIST ACTIONS/ACTION OPERATIONS
export const getListPublicAF = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { publicAFList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updatePublicAFList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            // return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListPublicAF())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListPublicAF())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { publicAFList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListPublicAF())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListPublicAF())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListPublicAF())
}

// APPLICATION FORM ADD ACTION OPERATIONS
export const uploadResume = (formData) => () => {
    return ApiService.post(Path.UPLOAD, formData)
        .then((response) => {
            return response
        }).catch((e) => {
            console.error(e)
        })
}

export const createPublicAF = (data, applicantId, isPublic, recaptchaResponse) => (dispatch, getState) => {
    const { publicAFAdd: { alert } } = getState()
    let nAlert = { ...alert }

    dispatch(Actions.showLoading(true))

    const payload = {
        ...data,
        recaptchaResponse: recaptchaResponse,  
    };

    const url = `${Path.ROOT}?isPublic=${isPublic}`;

    return ApiService.post(url, payload)
        .then((response) => {
            if (response) {
                let title = `THANK YOU! THE FORM HAS BEEN SUBMITTED`;
                const message = <SuccessMessage Id={`${applicantId}`} />;
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
            return response.data;
        })
        .catch((e) => {
            console.error(e)
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        });
}

export const getUniqueId = () => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.UNIQUEID)
        .then((response) => {
            let data = response ? response.data : '';
            dispatch(Actions.changeApplicantId(response))
            return data;
        });
}

export const getApplicantSkills = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.SKILLS, { company })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ label: item.skills, value: item.id })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const getJobHiringDDL = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.HIRING, { company })
        .then((response) => {
            let listData = response ? response.data : [];
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const showLegalDisclaimer = () => (dispatch, getState) => {
    const { publicAFAdd: { disclaimer } } = getState();
    let nDisclaimer = { ...disclaimer };

    nDisclaimer = {
        ...nDisclaimer,
        titles: 'DATA PRIVACY NOTICE',
        shows: true,
        contents: LegalDisclaimer(),
        goBackToList: false,
    };

    dispatch(Actions.showLoading(false));
    dispatch(Actions.showLegalDisclaimer(nDisclaimer));
}

export const handleUploadFile = (isUpdate = false) => (dispatch, getState) => {
    const state = getState();

    const fileUpload = isUpdate
        ? state.publicAFDetails.fileUpload
        : state.publicAFAdd.fileUpload;

    if (!fileUpload) return;

    let nFileUpload = {
        ...fileUpload,
        centered: true,
        fileShow: true,
        fileTitle: 'File Upload',
        size: 'md',
        acceptedFile: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'],
        subTitle: 'File must be of PDF, PNG, JPG formats',
    };

    dispatch(Actions.showLoading(false));

    if (isUpdate) {
        dispatch(Actions.showUpdateFileUploadModal(nFileUpload));
    } else {
        dispatch(Actions.showFileUploadModal(nFileUpload));
    }
};

// Public AF DETAIL/UPDATE ACTION OPERATIONS
export const getPublicAFById = (id, mode) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(`${Path.ROOT}/${id}`)
        .then((response) => {
            dispatch(Actions.setPublicAFDetail(response.data, mode))
            return response.data;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const getPublicAFByCode = (code, company, mode) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(`${Path.DETAIL}/${code}/${company}`)
        .then((response) => {
            dispatch(Actions.setPublicAFDetail(response.data, 'public'))
            return response.data;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}


export const exportPublicAFReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { publicAFList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId

    return ApiService.export(Path.EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const getResumeFile = (id, applicantId) => (dispatch) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id + '/' + applicantId)
        .then((response) => {
            if (response.status === 200) {
                const attachment = response.data;
                const binaryString = window.atob(attachment.contentBase64);
                const uint8Array = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }

                const blob = new Blob([uint8Array], { type: attachment.contentType });
                const attachmentFile = {
                    file: new File([blob], attachment.fileName, { type: attachment.contentType }),
                    attachmentId: attachment.attachmentID,
                };

                dispatch(Actions.setAttachmentData([attachmentFile]));
                return attachmentFile;
            } else {
                console.error('Failed to load attachment');
                return null;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        });
}

export const getCompanyId = (company) => (dispatch, getstate) => {
    dispatch(Actions.isLoading(true))
    return ApiService.get(`${Path.COMPANY}/${company}`)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const updatePublicAF = (detailData, ID) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    let updateModel = dispatch(convertToUpdateModel(detailData));

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + ID, updateModel)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const { message } = response.data
                let goBackToList = true
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : "Appplication sucessfully updated",
                    confirmLabel: 'OK',
                    goBackToListFlag: goBackToList,
                }

            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const syncApplicantWithEmployeeId = (currentApplicantId, employeeId) => (dispatch, getState) => {
    const { publicAFList: { alert } } = getState();
    let nAlert = { ...alert };

    dispatch(Actions.isLoading(true))

    const payload = {
        applicantId: currentApplicantId,
        employeeId: employeeId,
    };

    return ApiService.put(`${Path.SYNC_APPLICANT_TO_EMPLOYEE}`, payload)
        .then((response) => {
            if (response) {
                const { message } = response.data;
                let title = 'Sync Success';
                let goBackToList = true;

                if (response.data.returnCode <= 0) {
                    title = 'Sync Failed'
                    goBackToList = false
                }
                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            dispatch(Actions.updateListAlertData(nAlert))
            dispatch(Actions.isLoading(false))
            dispatch(getListPublicAF())
        });
};

export const errorDateTo = () => (dispatch, getState) => {
    const { publicAFAdd: { alert } } = getState();
    let nAlert = { ...alert };

    let title = 'Date Selection Notice';
    let message = 'Please ensure that the "To" date is at least one day after the "From" date.';
    let goBackToList = false;

    nAlert = {
        ...nAlert,
        title: title,
        show: true,
        content: message,
        goBackToListFlag: goBackToList,
    };

    dispatch(Actions.updateAddAlertData(nAlert));
};

export const convertToUpdateModel = (data) => (dispatch, getState) => {
    const { auth } = getState()

    return {
        ...data,
        Resume: {
            FileName: data.curriculumVitae.file.name,
        },
    }
}


export const validateEmail = (email, isApplicantEmail = false, isUpdate = false) => async (dispatch, getState) => {
    if (isUpdate) {
        dispatch(Actions.hasDetailLoaded(false));
    } else {
        dispatch(Actions.showLoading(true));
    }

    try {
        const response = await ApiService.post(Path.EMAILVALIDATION, { email });
        const state = getState();
        const alert = isUpdate ? state.publicAFDetails.alert : state.publicAFAdd.alert;

        if (!response.data.isValid && isApplicantEmail) {
            const nAlert = {
                ...alert,
                title: 'Invalid Email Address',
                show: true,
                content: `The email address "${email}" is incorrect or not valid. Please double-check.`,
                goBackToListFlag: false,
            };

            if (isUpdate) {
                dispatch(Actions.setDetailAlert(nAlert));
                dispatch(Actions.hasDetailLoaded(true));
            } else {
                dispatch(Actions.updateAddAlertData(nAlert));
                dispatch(Actions.showLoading(false));
            }
        }

        return response.data.isValid;
    } catch (error) {
        console.error('Error validating email:', error);

        if (isUpdate) {
            dispatch(Actions.hasDetailLoaded(true));
        } else {
            dispatch(Actions.showLoading(false));
        }

        return false;
    }
};

export const geteducationlevelName = (isUpdate = false) => async (dispatch, getState) => {
    if (isUpdate) {
        dispatch(Actions.hasDetailLoaded(false));
    } else {
        dispatch(Actions.showLoading(true));
    }
    let data;

    try {
        const response = await ApiService.get(Path.EDUCATIONAL_LEVEL_NAME);
        if (response) {
            data = response.data;
        }
    } catch (error) {
        console.error(error);
    } finally {
        if (isUpdate) {
            dispatch(Actions.hasDetailLoaded(true));
        } else {
            dispatch(Actions.showLoading(false));
        }
    }

    return data;
}
